/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_D2tInputs */

const en_mk_sol_ukm_d2t = /** @type {(inputs: Mk_Sol_Ukm_D2tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`09:00: complaints get answered in the right voice`)
};

const id_mk_sol_ukm_d2t = /** @type {(inputs: Mk_Sol_Ukm_D2tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`09.00: komplain dijawab dengan nada yang benar`)
};

/**
* | output |
* | --- |
* | "09:00: complaints get answered in the right voice" |
*
* @param {Mk_Sol_Ukm_D2tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_d2t = /** @type {((inputs?: Mk_Sol_Ukm_D2tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_D2tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_d2t(inputs)
	return en_mk_sol_ukm_d2t(inputs)
});